import { render } from "./TkContextBadge.vue?vue&type=template&id=d14bad4c&scoped=true"
import script from "./TkContextBadge.vue?vue&type=script&lang=js"
export * from "./TkContextBadge.vue?vue&type=script&lang=js"

import "./TkContextBadge.vue?vue&type=style&index=0&id=d14bad4c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d14bad4c"]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge});
